export const envData = { 
    baseApiUrl: "https://api.xceledu.ai", 
    stripePublicKey: "pk_live_51OsXgNP7HxKAiuniS4P3aGPgpyUQGXoUXe2GC6I3KySYQ8KCKBHYJwOKMY1fDfSxoM1eErNiI14Na7uDAGvFR9FQ003BagiP4Z", 
};

